import App from './App.svelte';
import '@shoelace-style/shoelace';
import '@shoelace-style/shoelace/dist/themes/base.css';
import '@shoelace-style/shoelace/dist/components/icon/icon.js';

const app = new App({
	target: document.body,
});

export default app;